export default __webpack_public_path__ + "static/media/user-arms.0761700d.svg";